import { MouseEvent } from "react";
import styles from "./Tabs.module.css";

interface TabsItemProps {
    title: string;
    active: boolean;
    canHover: boolean;
    onItemClick: (event: MouseEvent<HTMLElement>) => void;
}

/**
 * @author bakim
 * @date 2024-09-11 10:56:38
 * @remark 상단 탑 메뉴 아이템
 * @param {string} title: (required) 메뉴 명
 * @param {boolean} active : (required) 메뉴 선택 여부
 * @param  onItemClick: (required) 메뉴 선택(클릭) 시 콜백 함수
 * @returns TabsItem
 */
const TabsItem = (props: TabsItemProps) => {
    return (
        <div className={`${styles.item} ${props.active ? styles.select : ""} ${props.canHover ? styles.canHover : ""}`} onClick={props.onItemClick}>
            {props.title}
        </div>
    );
};

export default TabsItem;
